var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TableTransactionsDistribution',{staticClass:"mb-4",attrs:{"store":"accounting.transactions","default_filter":_vm.default_filter}})
}
var staticRenderFns = []

export { render, staticRenderFns }